import { AccountTree } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { IRideDto } from "@ryde/shared";

import { RideBottomBlockStyled } from "../ride.styled";

export interface IRideSearchRouteIterationIndicatorProps {
  rideDto?: Partial<IRideDto>;
}

export const RideSearchRouteIterationIndicator: FC<
  IRideSearchRouteIterationIndicatorProps
> = ({ rideDto }) => {
  const { t } = useTranslation();

  const routeIterationMatched = Number(
    rideDto?.metadata?.routeIterationMatched,
  );

  if (!(routeIterationMatched > 0)) {
    return null;
  }

  return (
    <RideBottomBlockStyled className="ride-search-route-iteration-indicator">
      <FramerTooltip
        content={t("ride.INDICATORS.routeIterationMatchedTooltip", {
          iteration: routeIterationMatched,
        })}
        rtlStrippedBottomLeftPlacement
      >
        <span>
          <AccountTree className="ride-indicators__search-route-iteration" />
        </span>
      </FramerTooltip>
    </RideBottomBlockStyled>
  );
};
